import 'css-chunksrc/client/pages/planzoneMembersPage/resource/styles.scss';export default {
  "resource": "_resource_1j1uz_1",
  "contextualMenu": "_contextualMenu_1j1uz_8",
  "compact": "_compact_1j1uz_27",
  "name": "_name_1j1uz_32",
  "deactivated": "_deactivated_1j1uz_32",
  "title": "_title_1j1uz_32",
  "form": "_form_1j1uz_44",
  "status": "_status_1j1uz_47",
  "subordinatesCol": "_subordinatesCol_1j1uz_47",
  "col": "_col_1j1uz_50",
  "tags": "_tags_1j1uz_58",
  "user": "_user_1j1uz_67",
  "avatar": "_avatar_1j1uz_77",
  "roleSelection": "_roleSelection_1j1uz_106",
  "icon": "_icon_1j1uz_129",
  "activateIcon": "_activateIcon_1j1uz_133",
  "hiddenTagsNbr": "_hiddenTagsNbr_1j1uz_145",
  "nameCell": "_nameCell_1j1uz_174",
  "readOnly": "_readOnly_1j1uz_188"
};